import Enumerator from './Enumerator';

export const iconTypes = [
  'account_balance',
  'account_circle',
  'add_box',
  'add_circle',
  'alarm',
  'build',
  'cake',
  'call',
  'cancel',
  'card_giftcard',
  'check_box',
  'check_circle',
  'contacts',
  'delete',
  'email',
  'error',
  'extension',
  'favorite',
  'folder',
  'forum',
  'grade',
  'group',
  'group_add',
  'help',
  'home',
  'hourglass_empty',
  'hourglass_full',
  'https',
  'indeterminate_check_box',
  'info',
  'lens',
  'lock',
  'local_hospital',
  'looks_one',
  'looks_two',
  'looks_3',
  'looks_4',
  'looks_5',
  'looks_6',
  'mood',
  'mood_bad',
  'note_add',
  'notifications',
  'pause_circle_filled',
  'play_circle_filled',
  'pageview',
  'perm_phone_msg',
  'person',
  'remove_circle',
  'report_problem',
  'school',
  'security',
  'stop',
  'settings',
  'star',
  'star_half',
  'thumb_down',
  'thumb_up',
  'verified_user',
  'voice_chat',
  'warning',
  'work',
  'event',
  'attach_money',
  'toll',
  'radio_button_checked',
  'font_download',
  'star_border',
  'radio_button_unchecked',
  'check_box_outline_blank',
  'whatshot',
  'share',
  'sentiment_dissatisfied',
  'sentiment_neutral',
  'sentiment_satisfied',
  'sentiment_very_dissatisfied',
  'sentiment_very_satisfied',
  'public',
  'notifications_none',
  'notifications_paused',
  'room_service',
  'golf_course',
  'free_breakfast',
  'business_center',
  'all_inclusive',
  'wifi',
  'time_to_leave',
  'sync',
  'personal_video',
  'ondemand_video',
  'event_available',
  'event_busy',
  'event_note',
  'create_new_folder',
  'folder_open',
  'folder_shared',
  'folder_special',
  'restaurant',
  'place',
  'map',
  'alarm_add',
  'alarm_off',
  'alarm_on',
  'announcement',
  'assessment',
  'assignment',
  'assignment_late',
  'assignment_return',
  'assignment_returned',
  'assignment_turned_in',
  'book',
  'bookmark',
  'bookmark_border',
  'chrome_reader_mode',
  'credit_card',
  'donut_large',
  'donut_small',
  'euro_symbol',
  'find_in_page',
  'fingerprint',
  'help_outline',
  'history',
  'info_outline',
  'label',
  'label_outline',
  'language',
  'pan_tool',
  'print',
  'receipt',
  'schedule',
  'search',
  'swap_vertical_circle',
  'thumbs_up_down',
  'timeline',
  'touch_app',
  'trending_down',
  'trending_flat',
  'trending_up',
  'view_agenda',
  'view_array',
  'view_carousel',
  'view_column',
  'view_day',
  'view_headline',
  'view_list',
  'view_module',
  'view_quilt',
  'view_stream',
  'view_week',
  'visibility',
  'visibility_off',
  'zoom_in',
  'zoom_out',
  'call_end',
  'contact_mail',
  'contact_phone',
  'dialpad',
  'mail_outline',
  'chat',
  'message',
  'comment',
  'voicemail',
  'vpn_key',
  'archive',
  'drafts',
  'unarchive',
  'inbox',
  'move_to_inbox'
];

export class IconType extends Enumerator {
  static default() {
    return this.of('info');
  }
}
IconType.initEnum(iconTypes);

export default {
  iconTypes,
  IconType
};
